import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default InfoOutlinedIcon;
